import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { PropertiesDashboardContextProvider } from '../contexts/PropertiesDashboard.context'
import { PropertiesDashboardController } from './PropertiesDashboard.controller'
import { PropertyDashboardFilterContextProvider } from './context/PropertyDashboardFilter.context'
import React from 'react'

/**
 * Page representing the overall client properties dashboard content.
 *
 * @example <PropertiesDashboard />
*/
export const PropertiesDashboard: React.FC = () => {

  return (
    <BKBNThemeWrapper>
      <PropertiesDashboardContextProvider>
        <PropertyDashboardFilterContextProvider>
          <PropertiesDashboardController />
        </PropertyDashboardFilterContextProvider>
      </PropertiesDashboardContextProvider>
    </BKBNThemeWrapper>
  )
}
